const enc = encodeURIComponent;
export function createLifecycle(t) {
    const post = (path, body) => t.request(path, { method: 'POST', body: JSON.stringify(body) });
    return {
        transition: (gadgetId, input) => post(`/gadgets/${enc(gadgetId)}/transition`, input),
        assign: (gadgetId, input) => post(`/gadgets/${enc(gadgetId)}/assign`, input),
        dispose: (gadgetId, input) => post(`/gadgets/${enc(gadgetId)}/dispose`, input),
        cost: (gadgetId) => t.request(`/gadgets/${enc(gadgetId)}/cost`),
        expiring: (withinDays) => t.request(`/gadgets/expiring${withinDays === undefined ? '' : `?withinDays=${withinDays}`}`),
        tickets: (gadgetId) => t.request(`/repairs?gadgetId=${enc(gadgetId)}`),
        advance: (ticketId, input) => post(`/repairs/${enc(ticketId)}/advance`, input),
        documents: (gadgetId) => t.request(`/gadgets/${enc(gadgetId)}/documents`),
    };
}
//# sourceMappingURL=lifecycle.js.map